/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import React from 'react';
import {Dialog, Snackbar} from '@dvrd/dvr-controls';

export class PopupController extends React.Component {
    renderUserIndependentComponents = () => {
        return (
            <>
                <Dialog/>
                <Snackbar/>
            </>
        )
    };

    render = () => {
        return <>
            {this.renderUserIndependentComponents()}
        </>
    };
}